/**
 * lucide-react v0.292.0 - ISC
 */
import createLucideIcon from '../createLucideIcon.js';
var Circle = createLucideIcon("Circle", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}]]);
export { Circle as default };